/**
 * Pure helpers for the services CSV import's category mapping. Thin wrappers
 * over the shared csv-import-dialog/mappingHelpers, kept so the services code
 * reads in its own terms.
 *
 * `categoryMap` is a plain object of { "<category name from the file>": <existing
 * category_id> }. A name that is absent means "create it as a new category".
 */
import {
  setChoice,
  mapToFields,
  describeMappings as describeGenericMappings,
} from "../../components/csv-import-dialog/mappingHelpers";

/**
 * Returns a new map with `name` pointed at `categoryId`. A blank, null or
 * undefined id removes the entry, i.e. goes back to "create new category".
 */
export function setCategoryChoice(categoryMap, name, categoryId) {
  return setChoice(categoryMap, name, categoryId);
}

/**
 * The extra multipart fields to send with the import calls. Empty when nothing
 * is mapped, so the API sees no `category_map` field at all.
 */
export function categoryMapToFields(categoryMap) {
  return mapToFields("category_map", categoryMap);
}

/** The organization's service categories as NewItemsPanel options. */
export function categoryOptions(categories) {
  return (categories || []).map((c) => ({
    id: c.category_id,
    label: c.category_name,
  }));
}

/**
 * Active mappings as display rows, sorted by the name from the file. Mappings
 * whose target category is unknown still show, with the id as a fallback label.
 */
export function describeMappings(categoryMap, categories) {
  return describeGenericMappings(categoryMap, categoryOptions(categories)).map(
    ({ name, id, label }) => ({
      name,
      categoryId: id,
      categoryName: label,
    })
  );
}
